// extracted by mini-css-extract-plugin
export default {"wrapperBtn":"NotificationButton_wrapperBtn__BUJGr","badge":"NotificationButton_badge__903gq"};